import { Button, Drawer, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCard, WrapperTabNav } from "./styled";
import React from "react";
import { useProducts } from "../../products";
import { useNavigate } from "react-router-dom";
import { TableSushiLunchProducts } from "./TableSushiLunchProducts";
import { SushiLunchProductsForm } from "./form/SushiLunchProductsForm";

const { Text } = Typography;

export const SushiLunchProducts = () => {
  const { querySelectorTransform } = useProducts();
  const [openModalCreateProduct, setOpenModalCreateProduct] =
    React.useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <AdminMenuLayout pageDescription="Productos" title="Productos">
      <WrapperCard>
        <div style={{ width: "100%" }}>
          <Text
            style={{ color: "gray", cursor: "pointer" }}
            onClick={() => navigate("/rules-sushi-lunch")}
          >
            Ir atrás
          </Text>
        </div>
        <WrapperTabNav
          items={[
            {
              label: `PRODUCTOS AÑADIDOS`,
              key: "3",
              children: (
                <>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={() => setOpenModalCreateProduct(true)}
                    >
                      Agregar producto
                    </Button>
                  </div>
                  <TableSushiLunchProducts
                    fetchQuery={querySelectorTransform}
                  />
                </>
              ),
            },
          ]}
        />
        <Drawer
          title={`Agregar producto`}
          open={openModalCreateProduct}
          width={"320px"}
          destroyOnClose
          onClose={() => setOpenModalCreateProduct(false)}
        >
          <SushiLunchProductsForm
            setOpenModalCreate={setOpenModalCreateProduct}
          />
        </Drawer>
      </WrapperCard>
    </AdminMenuLayout>
  );
};
